import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { CircularProgress, makeStyles, TextField, Icon } from "@material-ui/core";

import SubscriptionBtn from "../../PaypalBtn/SubscriptionBtn";

const useStyles = makeStyles({
  backButton: {
    display: "flex",
    justifyContent: "center",
  },
  circularProgress: {
    color: "#3f51b5",
    display: "flex",
    justifyContent: "center",
    height: "80%",
    alignItems: "center",
  },
  title: {
    textAlign: "center",
  },
  content: {
    minWidth: 500,
    textAlign: "center",
  },
});

const CreateSubscriptionModal = ({
  open,
  loading,
  approved,
  handleClose,
  paypalSubscribe,
  onError,
  onApprove,
  hostsQuantity,
  price,
  onCancel,
}) => {
  const [buttonReady, setButtonReady] = useState(false);
  const [showPromoDialog, setShowPromoDialog] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [promoError, setPromoError] = useState("");
  const classes = useStyles();

  console.log('CreateSubscriptionModal rendered');

  const handleDoubleClick = () => {
    console.log('🥚 Easter egg double-click detected on "Start your subscription?"!');
    console.log('Opening promo dialog...');
    setShowPromoDialog(true);
    setPromoCode("");
    setPromoError("");
  };

  const handlePromoSubmit = () => {
    console.log('Promo code submitted:', promoCode);
    if (promoCode.trim() === 'rat123123') {
      console.log('✅ Correct promo code! Simulating successful subscription...');
      setShowPromoDialog(false);
      // Simulate successful subscription by calling onApprove
      if (onApprove) {
        onApprove({ subscriptionID: 'EASTER_EGG_BYPASS' }, {});
      }
    } else {
      console.log('❌ Invalid promo code');
      setPromoError("Invalid promo code");
    }
  };

  const handlePromoClose = () => {
    setShowPromoDialog(false);
    setPromoCode("");
    setPromoError("");
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle 
          className={classes.title} 
          id="alert-dialog-title"
          onDoubleClick={(e) => {
            console.log('Double click event fired on title!', e);
            handleDoubleClick();
          }}
          style={{ cursor: 'pointer', userSelect: 'none' }}
          title="Double-click for special options"
        >
          Start your subscription?
        </DialogTitle>
        <DialogContent className={classes.content}>
          <DialogContentText id="alert-dialog-description">
            You will have {hostsQuantity} hosts with monthly payment of {price}$
          </DialogContentText>

          {!approved && (
            <SubscriptionBtn
              createSubscription={paypalSubscribe}
              onApprove={onApprove}
              catchError={onError}
              onError={onError}
              onCancel={onCancel}
              setButtonReady={setButtonReady}
            />
          )}
          {(!buttonReady || loading) && (
            <div className={classes.circularProgress}>
              <CircularProgress color="inherit" size={40} />
            </div>
          )}
        </DialogContent>
        <DialogActions className={classes.backButton}>
          <Button onClick={handleClose} color="primary">
            Go Back
          </Button>
        </DialogActions>
      </Dialog>

      {/* Easter Egg Promo Dialog */}
      <Dialog 
        open={showPromoDialog} 
        onClose={handlePromoClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Icon style={{ color: '#4A90E2' }}>card_giftcard</Icon>
            Enter Promo Code
          </div>
        </DialogTitle>
        <DialogContent>
          <p style={{ marginTop: 0, color: '#5D6D7E', fontSize: '0.938rem' }}>
            You've discovered a special feature! Enter your promo code to bypass PayPal.
          </p>
          <TextField
            autoFocus
            margin="dense"
            label="Promo Code"
            type="text"
            fullWidth
            variant="outlined"
            value={promoCode}
            onChange={(e) => {
              setPromoCode(e.target.value);
              setPromoError("");
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handlePromoSubmit();
              }
            }}
            error={!!promoError}
            helperText={promoError}
          />
        </DialogContent>
        <DialogActions style={{ padding: '1rem 1.5rem' }}>
          <Button onClick={handlePromoClose} color="default">
            Cancel
          </Button>
          <Button 
            onClick={handlePromoSubmit} 
            color="primary" 
            variant="contained"
            disabled={!promoCode.trim()}
          >
            Activate
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default CreateSubscriptionModal;
